export default __webpack_public_path__ + "static/media/Girdle of the Ascension.cd68503b.jpg";